var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultisigAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 7.5C3.75 6.25736 4.75736 5.25 6 5.25C7.24264 5.25 8.25 6.25736 8.25 7.5C8.25 8.74264 7.24264 9.75 6 9.75C4.75736 9.75 3.75 8.74264 3.75 7.5ZM6 3.75C3.92893 3.75 2.25 5.42893 2.25 7.5C2.25 9.57107 3.92893 11.25 6 11.25C7.81422 11.25 9.32753 9.96168 9.67499 8.25H14.25V10.5C14.25 10.9142 14.5858 11.25 15 11.25C15.4142 11.25 15.75 10.9142 15.75 10.5V8.25H21C21.4142 8.25 21.75 7.91421 21.75 7.5C21.75 7.08579 21.4142 6.75 21 6.75H15H9.67499C9.32753 5.03832 7.81422 3.75 6 3.75ZM3.75 16.5C3.75 15.2574 4.75736 14.25 6 14.25C7.24264 14.25 8.25 15.2574 8.25 16.5C8.25 17.7426 7.24264 18.75 6 18.75C4.75736 18.75 3.75 17.7426 3.75 16.5ZM6 12.75C3.92893 12.75 2.25 14.4289 2.25 16.5C2.25 18.5711 3.92893 20.25 6 20.25C7.81422 20.25 9.32753 18.9617 9.67499 17.25H17.25V19.5C17.25 19.9142 17.5858 20.25 18 20.25C18.4142 20.25 18.75 19.9142 18.75 19.5V17.25H21C21.4142 17.25 21.75 16.9142 21.75 16.5C21.75 16.0858 21.4142 15.75 21 15.75H18H9.67499C9.32753 14.0383 7.81422 12.75 6 12.75Z",
    fill: "#1B202C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultisigAccount);
export default __webpack_public_path__ + "static/media/multisig-account.0dc4c59f55c5bef799a6ff2f79aeb749.svg";
export { ForwardRef as ReactComponent };